import React, {Suspense} from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router';

import {NotFoundError} from 'shared/components';
import {ErpRoutePrefix} from 'shared/enums';
import {Box, CircularProgress} from '@emburse/ui-core';

const LoadingFallback = () => (
    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <CircularProgress/>
    </Box>
);

// Lazy-load each ERP so only the visited ERP's bundle is downloaded.
// A user on /netsuite never downloads Intacct or QuickBooks code.
const NetSuiteApp = React.lazy(() => import('./erps/netsuite/views/App/NetSuiteApp').then(m => ({default: m.NetSuiteApp})));
const IntacctApp = React.lazy(() => import('./erps/intacct/views/App/IntacctApp').then(m => ({default: m.IntacctApp})));
const QuickBooksApp = React.lazy(() => import('./erps/quickbooks/views/App/QuickBooksApp').then(m => ({default: m.QuickBooksApp})));
const XeroApp = React.lazy(() => import('./erps/xero/views/App/XeroApp').then(m => ({default: m.XeroApp})));

export const App = () => {
    return (
        <Router>
            <Suspense fallback={<LoadingFallback/>}>
                <Routes>
                    <Route path={ErpRoutePrefix.Netsuite} element={<NetSuiteApp/>}/>
                    <Route path={ErpRoutePrefix.Intacct} element={<IntacctApp/>}/>
                    <Route path={ErpRoutePrefix.QuickBooks} element={<QuickBooksApp/>}/>
                    <Route path={ErpRoutePrefix.Xero} element={<XeroApp/>}/>
                    <Route path={ErpRoutePrefix.Default} element={<NetSuiteApp/>}/>
                    <Route path="*" element={<NotFoundError/>}/>
                </Routes>
            </Suspense>
        </Router>
    );
};